import React from 'react';
import styled from 'styled-components';

import { Clickable } from 'shared/components';

import HomeIcon from 'assets/home-icon';
import ChevronIcon from 'assets/chevron-icon';

import CartButtonMobile from '../cart-button-mobile';

export function MenuNavMobile({ dispensaryName, isMenuPage, onIconClick, itemCount }) {
  return (
    <Container>
      {isMenuPage ? (
        <Clickable data-testid='back-icon' onClick={() => onIconClick(`back`)}>
          <StyledChevronIcon />
        </Clickable>
      ) : (
        <Clickable data-testid='home-icon' onClick={() => onIconClick(`home`)}>
          <HomeIcon />
        </Clickable>
      )}

      <DispensaryName>{dispensaryName}</DispensaryName>

      <CartButtonMobile
        variant='grey'
        // eslint-disable-next-line i18next/no-literal-string
        badgeVariant='white'
        onButtonClick={() => onIconClick(`cart`)}
        itemCount={itemCount}
      />
    </Container>
  );
}

const Container = styled.div`
  height: 60px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

const DispensaryName = styled.div`
  font-size: 16px;
  font-weight: bold;
  max-width: 250px;
  margin: 0 auto;
  text-align: center;
`;

const StyledChevronIcon = styled(ChevronIcon)`
  fill: ${({ theme }) => theme.colors.grey[60]};
  transform: rotate(90deg);
  height: 11px;
  cursor: pointer;
`;
